import React, { useRef } from "react";

import { Switch as MaterialSwitch } from "@material-ui/core";
import { useField, useFormikContext } from "formik";

import { Column } from "components/Layout";

import { SwitchProps as MaterialSwitchProps } from "@material-ui/core/Switch/Switch";
import { Error } from "./Error";
import { Label } from "./Label";

interface SwitchProps extends MaterialSwitchProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- Column component props
  colProps?: Record<string, any>;
  onChangeExtra?: (value: boolean) => void;
  label: string | React.ReactNode;
  tooltip?: string | React.ReactNode;
  altTooltip?: string | React.ReactNode;
  altColor?: string;
  innerRef?: React.Ref<HTMLInputElement>;
  alignCenter?: boolean;
}

export const Switch: React.FC<SwitchProps> = ({
  color = "primary",
  colProps = {},
  disabled,
  label,
  name,
  onChangeExtra,
  required,
  tooltip,
  altTooltip,
  altColor,
  innerRef,
  alignCenter = false,
}) => {
  const [field, meta] = useField(name);
  const inputRef = useRef<HTMLInputElement>(null);

  const { setFieldTouched, setFieldValue } = useFormikContext();

  function onChange() {
    const nextValue = !field.value;
    setFieldTouched(name, true, false);
    setFieldValue(name, nextValue);
    if (typeof onChangeExtra === "function") {
      onChangeExtra(nextValue);
    }
  }

  return (
    <Column {...colProps} fullWidth>
      {(label || tooltip) && (
        <Label
          htmlFor={name}
          required={required}
          tooltip={tooltip}
          altTooltip={altTooltip}
          altColor={altColor}
          justifyStart
          error={!!meta.error}
          alignCenter={alignCenter}
        >
          {label}
        </Label>
      )}
      <MaterialSwitch
        data-tour={field.name}
        aria-labelledby={name}
        name={name}
        onBlur={field.onBlur}
        onChange={onChange}
        disabled={disabled}
        required={required}
        inputRef={innerRef || inputRef}
        checked={field.value || false}
        color={color}
      />
      {meta.error && <Error>{meta.error}</Error>}
    </Column>
  );
};
